export default "__VITE_ASSET__fc7e4722__"